(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62752,61578,69100,75109,52502],{

/***/ 560327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getBanners; },
/* harmony export */   "Q": function() { return /* binding */ BannerInlinePlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _constants_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(346115);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167520);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(901550);
/* harmony import */ var _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(603651);






const filterHeightInlineInRootNode = (banners, isMobile) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  let sizePopups = [];
  for (let obj of banners) {
    let content = obj.content;
    for (let key in content) {
      if (content.hasOwnProperty(key)) {
        if (content[key].parentId === "ROOT" && content[key].tag === "inlinebanner" && ((_c = (_b = (_a = content[key]) == null ? void 0 : _a.customAttributes) == null ? void 0 : _b.inlinebanner) == null ? void 0 : _c.relativePosition) === _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .ERelativePosition.IN */ .zH.IN) {
          const isPopUpShowInDesktop = !((_g = (_f = (_e = (_d = content[key]) == null ? void 0 : _d.customAttributes) == null ? void 0 : _e.inlinebanner) == null ? void 0 : _f.responsive) == null ? void 0 : _g.hiddenMd);
          const isPopUpShowInMobile = !((_k = (_j = (_i = (_h = content[key]) == null ? void 0 : _h.customAttributes) == null ? void 0 : _i.inlinebanner) == null ? void 0 : _j.responsive) == null ? void 0 : _k.hiddenXs);
          if (isMobile && isPopUpShowInMobile || !isMobile && isPopUpShowInDesktop) {
            sizePopups.push({
              className: content[key].customAttributes.inlinebanner.cssSelector,
              height: (_l = content[key].style.height) != null ? _l : 0,
              width: (_m = content[key].style.width) != null ? _m : 0
            });
          }
        }
      }
    }
  }
  return sizePopups;
};
const getBanners = async ({
  cookies,
  configs,
  env,
  flagsup
}) => {
  const { appId, iamId, trackingAppId, url, isMobile } = configs;
  const parsedCookies = cookie__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Q(cookies);
  const isNewVisitor = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VP */ .CP] !== _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .UNIDENTIFIED */ .eF || parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VS */ .U6] === _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .NEW_USER */ .MB;
  const trackingId = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TRACKING_ID */ .tz];
  const isMa79Enabled = flagsup.epic_ma_79;
  const handleSubscribe = async () => {
    if (!appId)
      return;
    try {
      const discoveryService = new _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__/* .OnSiteDiscoveryService */ .T(env);
      const body = {
        appId,
        iamId,
        trackingAppId,
        onlyNewVisitor: isNewVisitor,
        url,
        trackingId: isMa79Enabled ? trackingId : void 0
      };
      const banners2 = await discoveryService.subscribeSmartPopup(body);
      return filterHeightInlineInRootNode(banners2, isMobile);
    } catch (e) {
      console.error(e);
    }
  };
  const banners = await handleSubscribe() || [];
  return banners;
};
const BannerInlinePlaceholder = ({
  banners = [],
  className
}) => {
  const matchBanners = banners == null ? void 0 : banners.filter(
    (banner) => banner.className === `.${className}`
  );
  const totalBannerHeight = matchBanners == null ? void 0 : matchBanners.reduce(
    (total, banner) => total + banner.height,
    0
  );
  const maxBannerWidth = matchBanners == null ? void 0 : matchBanners.reduce(
    (max, banner) => Math.max(max, banner.width),
    0
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: matchBanners ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className,
      style: {
        minHeight: `${totalBannerHeight}px`,
        width: `${maxBannerWidth}px`
      }
    }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className
    })
  });
};




/***/ }),

/***/ 346115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CP": function() { return /* binding */ TEMPI_VP; },
/* harmony export */   "GN": function() { return /* binding */ DEFAULT_LIMIT_TIME; },
/* harmony export */   "Hi": function() { return /* binding */ RETURNING; },
/* harmony export */   "J2": function() { return /* binding */ SMART_POPUP_CONFIG; },
/* harmony export */   "MB": function() { return /* binding */ NEW_USER; },
/* harmony export */   "SI": function() { return /* binding */ EXPIRE_MINUTE; },
/* harmony export */   "U6": function() { return /* binding */ TEMPI_VS; },
/* harmony export */   "eF": function() { return /* binding */ UNIDENTIFIED; },
/* harmony export */   "hR": function() { return /* binding */ DEFAULT_DISPLAY_VALUE; },
/* harmony export */   "to": function() { return /* binding */ VIEW_INTERVAL_DURATION; },
/* harmony export */   "tz": function() { return /* binding */ TRACKING_ID; }
/* harmony export */ });
const EXPIRE_MINUTE = 20;
const TEMPI_VP = "_tempi_vp";
const TEMPI_VS = "_tempi_vs";
const SMART_POPUP_CONFIG = "_smart_banner_config";
const NEW_USER = "NEW";
const RETURNING = "RETURNING";
const UNIDENTIFIED = "unidentified";
const VIEW_INTERVAL_DURATION = 100;
const DEFAULT_DISPLAY_VALUE = 1;
const DEFAULT_LIMIT_TIME = 1;
const TRACKING_ID = "_track__track";




/***/ }),

/***/ 603651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ OnSiteDiscoveryService; }
/* harmony export */ });
/* harmony import */ var _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(988966);


const onSiteDiscoveryUrl = {
  dev: "https://smart-activation-discovery.dev.tekoapis.net/api",
  stag: "https://smart-activation-discovery.stag.tekoapis.net/api",
  production: "https://smart-activation-discovery.tempi.vn/api"
};
class OnSiteDiscoveryService {
  constructor(env) {
    this.client = new _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__/* .Api */ .V(onSiteDiscoveryUrl[env]);
  }
  async subscribeSmartPopup(params) {
    var _a;
    const { data } = await this.client.post(
      "/v1/smart-activation/subscribe",
      params
    );
    return ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.popups) || [];
  }
}




/***/ }),

/***/ 901550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RW": function() { return /* binding */ ETimeUnit; },
/* harmony export */   "Wv": function() { return /* binding */ EBannerEvent; },
/* harmony export */   "zH": function() { return /* binding */ ERelativePosition; }
/* harmony export */ });
var EBannerEvent = /* @__PURE__ */ ((EBannerEvent2) => {
  EBannerEvent2[EBannerEvent2["DISPLAY"] = 0] = "DISPLAY";
  EBannerEvent2[EBannerEvent2["CLICK"] = 1] = "CLICK";
  EBannerEvent2[EBannerEvent2["CLOSE"] = 2] = "CLOSE";
  return EBannerEvent2;
})(EBannerEvent || {});
var ETimeUnit = /* @__PURE__ */ ((ETimeUnit2) => {
  ETimeUnit2[ETimeUnit2["MINUTE"] = 0] = "MINUTE";
  ETimeUnit2[ETimeUnit2["HOUR"] = 1] = "HOUR";
  ETimeUnit2[ETimeUnit2["SESSION"] = 1] = "SESSION";
  return ETimeUnit2;
})(ETimeUnit || {});
var ERelativePosition = /* @__PURE__ */ ((ERelativePosition2) => {
  ERelativePosition2["BEFORE"] = "before";
  ERelativePosition2["AFTER"] = "after";
  ERelativePosition2["IN"] = "in";
  return ERelativePosition2;
})(ERelativePosition || {});




/***/ }),

/***/ 380822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ s; }
/* harmony export */ });
class s{constructor(s,e,t){this.message=s,this.response=t,this.code=e}get reason(){return this.response}}


/***/ }),

/***/ 988966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83492);
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(opentracing__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _error_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(380822);
var s=Object.defineProperty,a=Object.defineProperties,n=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(t,e,r)=>e in t?s(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,h=(t,e)=>{for(var r in e||(e={}))i.call(e,r)&&p(t,r,e[r]);if(o)for(var r of o(e))c.call(e,r)&&p(t,r,e[r]);return t};const l=(t="",e)=>`${t.endsWith("/")?t.slice(0,t.length-1):t}/${e.startsWith("/")?e.slice(1):e}`;class u{constructor(t,e,r={}){this.baseURL=t,this.interceptors=[],this.getError=e,this.defaultConfig=r}_parseJson(t){return t.text().then((t=>t?JSON.parse(t):null))}addInterceptor(t){this.interceptors.push(t)}appendParamsToURL(t,e={}){if(e){const r=[];for(const t of Object.keys(e))null!==e[t]&&void 0!==e[t]&&r.push(`${t}=${encodeURIComponent(e[t])}`);r.length>0&&(t=`${t}?${r.join("&")}`)}return t}async request(s,o,i,c={}){var p;const{params:u}=c;let f=c.headers||{};const d=this.appendParamsToURL(s,u||{});let g=null;const y=o&&"string"!=typeof o&&"append"in o;o&&"string"!=typeof o&&(y?g=new URLSearchParams(o).toString():(g=JSON.stringify(o),f=h({"Content-Type":"application/json"},f)));let b=null;u&&(b=JSON.stringify(u));const m=(0,opentracing__WEBPACK_IMPORTED_MODULE_0__.globalTracer)(),w=`[${i}] ${l(this.baseURL,s)}`,O=m.startSpan(w);m.inject(O,opentracing__WEBPACK_IMPORTED_MODULE_0__.FORMAT_HTTP_HEADERS,f),O.setTag("http.method",i),O.setTag("http.baseurl",this.baseURL),O.log({body:g,params:b});const j=(P=h({},this.defaultConfig),T={method:i,headers:new Headers(f),body:y?o:g},a(P,n(T)));var P,T;this.interceptors.forEach((t=>t(j)));const E=await fetch(d.startsWith("http")?d:l(this.baseURL,d),j);if(E.status>=400){const t=await E.json(),e=(null==(p=this.getError)?void 0:p.call(this,t))||new _error_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ApiError */ .M("Đã có lỗi xảy ra, vui lòng thử lại sau!",-1,t);return O.setTag("status","error"),O.log({error:JSON.stringify(e)}),O.finish(),Promise.reject(e)}const v={};E.headers.forEach(((t,e)=>v[e]=t));const S=await this._parseJson(E);return O.setTag("status","success"),O.finish(),{code:E.status,data:S,headers:v}}async get(t,e={}){return await this.request(t,null,"GET",e)}async post(t,e,r={}){return await this.request(t,e,"POST",r)}async patch(t,e,r={}){return await this.request(t,e,"PATCH",r)}async put(t,e,r={}){return await this.request(t,e,"PUT",r)}async delete(t,e={},r={}){return await this.request(t,e,"DELETE",r)}}


/***/ }),

/***/ 321708:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={815:function(e){function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}e.exports=function(e,n,t,o){n=n||"&";t=t||"=";var a={};if(typeof e!=="string"||e.length===0){return a}var i=/\+/g;e=e.split(n);var u=1e3;if(o&&typeof o.maxKeys==="number"){u=o.maxKeys}var c=e.length;if(u>0&&c>u){c=u}for(var p=0;p<c;++p){var f=e[p].replace(i,"%20"),s=f.indexOf(t),_,l,y,d;if(s>=0){_=f.substr(0,s);l=f.substr(s+1)}else{_=f;l=""}y=decodeURIComponent(_);d=decodeURIComponent(l);if(!hasOwnProperty(a,y)){a[y]=d}else if(r(a[y])){a[y].push(d)}else{a[y]=[a[y],d]}}return a};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"}},577:function(e){var stringifyPrimitive=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,o,a){t=t||"&";o=o||"=";if(e===null){e=undefined}if(typeof e==="object"){return map(n(e),(function(n){var a=encodeURIComponent(stringifyPrimitive(n))+o;if(r(e[n])){return map(e[n],(function(e){return a+encodeURIComponent(stringifyPrimitive(e))})).join(t)}else{return a+encodeURIComponent(stringifyPrimitive(e[n]))}})).join(t)}if(!a)return"";return encodeURIComponent(stringifyPrimitive(a))+o+encodeURIComponent(stringifyPrimitive(e))};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"};function map(e,r){if(e.map)return e.map(r);var n=[];for(var t=0;t<e.length;t++){n.push(r(e[t],t))}return n}var n=Object.keys||function(e){var r=[];for(var n in e){if(Object.prototype.hasOwnProperty.call(e,n))r.push(n)}return r}}};var r={};function __nccwpck_require__(n){var t=r[n];if(t!==undefined){return t.exports}var o=r[n]={exports:{}};var a=true;try{e[n](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete r[n]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.decode=e.parse=__nccwpck_require__(815);e.encode=e.stringify=__nccwpck_require__(577)}();module.exports=n})();

/***/ }),

/***/ 685172:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// TODO: Maybe, we do not need to export them.
var simplify_callback_1 = __webpack_require__(505828);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return simplify_callback_1.StreamEvent; } });
var subscription_1 = __webpack_require__(596773);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return subscription_1.createDataStream; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return subscription_1.createSubscription; } });
var wrap_global_1 = __webpack_require__(513371);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return wrap_global_1.getModuleEnvironment; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return wrap_global_1.wrapModule; } });
const utils_1 = __webpack_require__(841405);
const wrap_global_2 = __webpack_require__(513371);
function setWrapModuleToGlobal() {
    // @ts-ignore
    __webpack_require__.g['wrapModule'] = wrap_global_2.wrapModule;
    // @ts-ignore
    __webpack_require__.g['isTerraAvailable'] = utils_1.checkIsTerraAvailable;
}
setWrapModuleToGlobal();


/***/ }),

/***/ 505828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.simplifyCallback = exports.StreamEvent = void 0;
const subscription_1 = __webpack_require__(596773);
const utils_1 = __webpack_require__(841405);
/**
 * Represents stream events that be used to communicate state of the stream
 * from native to web.
 */
var StreamEvent;
(function (StreamEvent) {
    StreamEvent["STREAM_TERMINATED"] = "STREAM_TERMINATED";
})(StreamEvent = exports.StreamEvent || (exports.StreamEvent = {}));
/**
 * Convert the callback to a stream to receive continual values.
 * @template T The emission value type.
 * @param global The global object - generally window.
 * @param param1 Parameters for stream creation.
 * @return A stream that can be subscribed to.
 */
function streamCallback(global, { callbackNameFunc, funcToWrap }) {
    return subscription_1.createDataStream((handlers) => {
        /** Generate callback name dynamically to make this stream idempotent. */
        const callbackName = callbackNameFunc();
        let subscription;
        global[callbackName] = (data) => {
            if (utils_1.isType(data.result, 'event')) {
                switch (data.result.event) {
                    case StreamEvent.STREAM_TERMINATED:
                        subscription.unsubscribe();
                        break;
                }
            }
            else {
                const { result, error, status_code } = data;
                !!handlers &&
                    !!handlers.next &&
                    handlers.next({
                        result: result === null ? undefined : utils_1.parseJson(result),
                        error: error === null ? undefined : error,
                        status_code: status_code === null ? undefined : status_code,
                    });
            }
        };
        /**
         * Beware that this function may throw a non-recoverable error, such
         * as module not available. In that case, we should let this call fail
         * and ensure the error is caught downstream.
         */
        funcToWrap(callbackName);
        subscription = subscription_1.createSubscription(() => {
            /**
             * Native should check for the existence of this callback every time a
             * value is bound to be delivered. If no such callback exists, it may
             * be assumed that the web client has unsubscribed from this stream, and
             * therefore the stream may be terminated on the mobile side.
             */
            global[callbackName] = undefined;
            !!handlers && !!handlers.complete && handlers.complete();
        });
        return subscription;
    });
}
/**
 * Handle the simplication of callbacks for both single asynchronous return
 * values and streams.
 * @param global The global object - generally window.
 * @param param1 Parameters for callback simplification.
 * @return Check the return types for private functions in this module.
 */
function simplifyCallback(global, _a) {
    var { funcNameToWrap } = _a, restParams = __rest(_a, ["funcNameToWrap"]);
    return streamCallback(global, restParams);
}
exports.simplifyCallback = simplifyCallback;


/***/ }),

/***/ 596773:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createDataStream = exports.createSubscription = void 0;
/**
 * Create a subscription that can only be unsubscribed from once.
 * @param unsubscribe Unsubscription logic.
 */
function createSubscription(unsubscribe) {
    let unsubscribed = false;
    return {
        isUnsubscribed: () => unsubscribed,
        unsubscribe: () => {
            if (!unsubscribed) {
                unsubscribe();
                unsubscribed = true;
            }
        },
    };
}
exports.createSubscription = createSubscription;
/**
 * Create a data stream with default functionalities. When we implement
 * Promise functionalities, beware that if then block is executed immediately
 * (i.e. a resolved promise), the subscription object may not be created yet.
 *
 * The call to subscribe may throw an error which we need to catch, due to the
 * asynchronous nature of Promises. This error will then be passed to the
 * reject call.
 * @param subscribe Injected subscribe function.
 * @return A DataStream instance.
 */
function createDataStream(subscribe) {
    return {
        subscribe,
        then: (onFulfilled, onRejected) => {
            return new Promise((resolve, reject) => {
                try {
                    let subscription = null;
                    let didFinish = false;
                    subscription = subscribe({
                        next: data => {
                            if (onFulfilled == null) {
                                // @ts-ignore
                                resolve(undefined);
                            }
                            else {
                                resolve(onFulfilled(data));
                            }
                            !!subscription && subscription.unsubscribe();
                            didFinish = true;
                        },
                    });
                    if (didFinish)
                        !!subscription && subscription.unsubscribe();
                }
                catch (e) {
                    if (onRejected == null) {
                        reject(e);
                    }
                    else {
                        resolve(onRejected(e));
                    }
                }
            });
        },
    };
}
exports.createDataStream = createDataStream;


/***/ }),

/***/ 841405:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkIsTerraAvailableIOS = exports.checkIsTerraAvailableAndroid = exports.checkIsTerraAvailable = exports.parseJson = exports.wrapModuleName = exports.isType = exports.getFirstAvailableCallbackName = exports.getCallbackName = exports.getObjectKeys = void 0;
/**
 * Get the keys of an object.
 * @param object Some object.
 * @return Array of object keys.
 */
function getObjectKeys(object) {
    return [...Object.keys(object), ...Object.getOwnPropertyNames(Object.getPrototypeOf(object))];
}
exports.getObjectKeys = getObjectKeys;
/**
 * Get the callback name that will be used to access global callback.
 * @param param0 The required parameters.
 * @return The combined callback name.
 */
function getCallbackName({ moduleName, funcName, requestID: req, }) {
    return `${moduleName}_${funcName}Callback${req !== null ? `_${req}` : ''}`;
}
exports.getCallbackName = getCallbackName;
/**
 * Instead of keeping state, find the first available callback name by
 * iterating through all callback names in the global object and pick the next
 * one.
 */
function getFirstAvailableCallbackName(global, { moduleName, funcName }) {
    let nextAvailableRequestID = 0;
    return (() => {
        let callbackName = '';
        while ((callbackName = getCallbackName({
            moduleName,
            funcName,
            requestID: nextAvailableRequestID,
        })) in global) {
            nextAvailableRequestID += 1;
        }
        nextAvailableRequestID += 1;
        return callbackName;
    })();
}
exports.getFirstAvailableCallbackName = getFirstAvailableCallbackName;
/**
 * Check if an object is of a certain type.
 * @param object Some object.
 * @return Whether the object is of this type.
 */
function isType(object, ...keys) {
    if (!object)
        return false;
    const objectKeys = getObjectKeys(object);
    return keys.every((key) => objectKeys.indexOf(key) >= 0);
}
exports.isType = isType;
/**
 * Wrap a module name to mark it as wrapped.
 * @param moduleName The original module name.
 * @return The wrapped module name.
 */
function wrapModuleName(moduleName) {
    return `Wrapped${moduleName}`;
}
exports.wrapModuleName = wrapModuleName;
function parseJson(json) {
    if (typeof json != 'string') {
        return json;
    }
    try {
        return JSON.parse(json);
    }
    catch (error) {
        return json;
    }
}
exports.parseJson = parseJson;
function checkIsTerraAvailable() {
    return checkIsTerraAvailableAndroid() || checkIsTerraAvailableIOS();
}
exports.checkIsTerraAvailable = checkIsTerraAvailable;
function checkIsTerraAvailableAndroid() {
    // @ts-ignore
    return !!__webpack_require__.g['TerraWebModule'];
}
exports.checkIsTerraAvailableAndroid = checkIsTerraAvailableAndroid;
function checkIsTerraAvailableIOS() {
    // @ts-ignore
    return !!__webpack_require__.g.webkit && !!__webpack_require__.g.webkit.messageHandlers && !!__webpack_require__.g.webkit.messageHandlers['TerraWebModule'];
}
exports.checkIsTerraAvailableIOS = checkIsTerraAvailableIOS;


/***/ }),

/***/ 4868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wrapGenericModule = void 0;
const simplify_callback_1 = __webpack_require__(505828);
const utils_1 = __webpack_require__(841405);
/**
 * Wrap a generic module. This should work for both Android and iOS-injected
 * Javascript interfaces.
 * @param global The global object - generally window.
 * @param moduleName The name of the module that owns the method.
 * @param moduleMethodFunc Function to execute the related module method.
 * @return The wrapped module.
 */
function wrapGenericModule(global, moduleName, moduleMethodFunc) {
    return {
        invoke: (method, params) => {
            return simplify_callback_1.simplifyCallback(global, {
                funcNameToWrap: method,
                callbackNameFunc: () => utils_1.getFirstAvailableCallbackName(global, {
                    moduleName,
                    funcName: method,
                }),
                funcToWrap: callback => moduleMethodFunc({
                    subscriberId: callback,
                    method,
                    module: moduleName,
                    parameters: params !== undefined && params !== null ? params : {},
                }),
            });
        },
    };
}
exports.wrapGenericModule = wrapGenericModule;


/***/ }),

/***/ 513371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Grab Taxi Holdings PTE LTD (GRAB)
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wrapModule = exports.getModuleEnvironment = void 0;
const utils_1 = __webpack_require__(841405);
const wrap_generic_1 = __webpack_require__(4868);
/**
 * Get the module's mobile environment.
 * @param global The global object - generally window.
 * @param moduleName The name of the module being wrapped.
 */
function getModuleEnvironment(global, moduleName) {
    if (!!global[moduleName]) {
        return 'android';
    }
    else if (!!global.webkit && !!global.webkit.messageHandlers && !!global.webkit.messageHandlers[moduleName]) {
        return 'ios';
    }
    return undefined;
}
exports.getModuleEnvironment = getModuleEnvironment;
/**
 * Wrap the appropriate module based on whether or not it's Android/iOS.
 * @param global The global object - generally window.
 * @param moduleName The name of the module being wrapped.
 */
function wrapModule(global, moduleName) {
    global[utils_1.wrapModuleName(moduleName)] = wrap_generic_1.wrapGenericModule(global, moduleName, (params) => {
        if (!!global['TerraWebModule']) {
            //this case for android
            global['TerraWebModule'].invoke(moduleName, params.method, params.subscriberId, JSON.stringify(params));
        }
        else if (!!global.webkit &&
            !!global.webkit.messageHandlers &&
            !!global.webkit.messageHandlers['TerraWebModule']) {
            //this case for ios
            global.webkit.messageHandlers['TerraWebModule'].postMessage({
                moduleName: moduleName,
                methodName: params.method,
                subscriberId: params.subscriberId,
                requestString: JSON.stringify(params),
            });
        }
        else {
            throw new Error(`Unexpected method '${params.method}' for module '${moduleName}'`);
        }
    });
}
exports.wrapModule = wrapModule;


/***/ }),

/***/ 167520:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
__webpack_unused_export__ = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.partitioned) {
    str += '; Partitioned'
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ })

}]);